import React from 'react';
import './ProfileDetails.css';

import { FaFacebookF, FaInstagram, FaLinkedin, FaEnvelope, FaMapMarkerAlt, FaBriefcase, FaPhoneAlt, FaBuilding, FaTrophy } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';



const ProfileDetails = ({ profile, isSpeaker }) => {

  const accounts = profile.accounts;
  const contacts = profile.contacts;
  const skillsContent = profile.skills;
  const experience = profile.experience;
  const achievements = profile.achievements;

  return (

    <>

      <div className={`${isSpeaker ? 'speaker-single' : 'team-single'} profile-single`}>

        {/* Profile Introduction */}
        <div className='profile-intro'>

          {/* Profile Image */}
          <div className='image'>
            <img src={profile.image} alt={profile.name} />
          </div>

          {/* Profile Details */}
          <div className='information'>

            <h3>{profile.name}</h3> {/* Profile Name */}
            <h5>{profile.title}</h5> {/* Profile Title */}

            {/* Profile About */}
            <div className='profile-about'>
              <div className='text'>{profile.biography}</div> {/* Profile Biography */}
            </div>

            <ul className="profile-personal-info">
              <li> 
                <div className='title'>
                  <div className='icon'><FaPhoneAlt /></div>
                  <h6>Phone:</h6>
                </div> 
                <span>{contacts.phone}</span>
              </li>
              <li> 
                <div className='title'>
                  <div className='icon'><FaEnvelope /></div>
                  <h6>Email:</h6>
                </div> 
                <span>{contacts.email}</span>
              </li>
              <li> 
                <div className='title'>
                  <div className='icon'><FaMapMarkerAlt /></div>
                  <h6>Website:</h6>
                </div> 
                <span>{contacts.website}</span>
              </li>
              {isSpeaker && (
                <>
                  <li> 
                    <div className='title'>
                      <div className='icon'><FaBuilding /></div>
                      <h6>Company:</h6>
                    </div> 
                    <span>{contacts.company}</span>
                  </li>
                  <li> 
                    <div className='title'>
                      <div className='icon'><FaBriefcase /></div>
                      <h6>Experience:</h6>
                    </div> 
                    <span>{contacts.experience}</span>
                  </li>
                </>
              )}
            </ul>

            {/* Social media icons */}
            <div className='icon-container'>
              <a className='icon' href={accounts.facebook}><FaFacebookF /></a> {/* Facebook Icon */}
              <a className='icon' href={accounts.linkedin}><FaLinkedin /></a> {/* LinkedIn Icon */}
              <a className='icon' href={accounts.twitter}><FaXTwitter /></a> {/* Twitter Icon */}
              <a className='icon' href={accounts.instagram}><FaInstagram /></a> {/* Instagram Icon */}
            </div>

          </div>

        </div>

        <div className='box-container page-info'>

          {/* Profile Experience */}
          <div className='profile-experience sub-section'>
          <h4>{isSpeaker ? 'Awards & Achievements' : 'Personal Experience'}</h4>
          <p>
            {isSpeaker
              ? `${profile.name} has earned recognition for impactful contributions to AI and SaaS innovation.`
              : `${profile.name} brings hands-on experience in building and scaling AI-driven SaaS solutions.`}
          </p>

            <ul>
              {(isSpeaker ? achievements : experience).map((list, index) => (
                <li key={index}>
                  <div className='icon'>{isSpeaker ? <FaTrophy /> : <FaBriefcase />}</div>
                  {list}
                </li>
              ))}
            </ul>

          </div>
  
          {/* Profile Skills */}
          <div className='profile-skills sub-section'>
            <h4>{isSpeaker ? 'Professional Skills' : 'Skills'}</h4>

            {/* Skills Container */}
            <div className='skills'>
              <div className='skill-item'>
                {skillsContent.map(skill => (
                  <div className='box' key={skill.id}> 
                    <h3>{skill.title}<span> {skill.progress}% </span> </h3>
                    <div className='progress-bar'> <span style={{ width: `${skill.progress}%` }}></span> </div>
                  </div>
                ))}
              </div>
            </div>

          </div>

        </div>

      </div>

    </>

  );
}

export default ProfileDetails;